export enum UserRole {
  ORIGINATOR_MEMBER = "ORIGINATOR_MEMBER",
  ORIGINATOR_ADMIN = "ORIGINATOR_ADMIN",
  LAT_MEMBER = "LAT_MEMBER",
  LAT_ADMIN = "LAT_ADMIN",
  LAT_ANALYST = "LAT_ANALYST",
  LAT_APPROVER = "LAT_APPROVER",
  LAT_TREASURER = "LAT_TREASURER",
  ORIGINATOR_SIGNEE = "ORIGINATOR_SIGNEE",
  ORIGINATOR_BR_MEMBER = "ORIGINATOR_BR_MEMBER",
  ORIGINATOR_TY_MEMBER = "ORIGINATOR_TY_MEMBER"
}

export enum CustomerAccountType {
  originator = "ORIGINATOR"
}
